import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { formatDbDateWithoutTime } from '../../../utils/dateFormater';
import { UpdateStatusAction } from '../../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../loader/loader';
import DefaultAvatar from "../../images/default_avatar.jpg"
import HoverFullText from '../../../elements/HoverToolKit';
const SingleAdmin = ({ PMM, index, totalPMMs }) => {

    const [copied, setCopied] = useState(false);


    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState("");
    const [popupHeading, setPopupHeading] = useState("");
    const [popupPara, setPopupPara] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.inviteUser)
    const { user } = useSelector(state => state.verifyEmailStore);


    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const displayIndex = String(totalPMMs - index).padStart(2, '0');



    const handleUpdateStatus = (userId, UserStatus) => {

        let userData = {
            id: userId,
            status: UserStatus
        }

        dispatch(UpdateStatusAction(userData));

    }








    return (
        <Fragment>
            {loading && <Loader />}
            <div className="flex flex-col min-w-[1400px] border border-zinc-100 border-l-4 border-l-indigo-600 bg-white rounded-r-xl rounded-l-md hover:shadow-md transition-all mb-[1vmax] relative" >
                {Number(PMM?.active_reports_count) > 0 &&
                    <div className={`absolute top-0 left-0 text-[0.75vmax] font-jakarta font-bold p-[0.2vmax_0.8vmax] 
                        ${Number(PMM?.active_reports_count) > 20 ? "bg-red-500" : 
                          Number(PMM?.active_reports_count) > 10 ? "bg-orange-400" : "bg-emerald-500"} 
                        text-white rounded-br-lg`}
                    >
                        {PMM?.active_reports_count} Active Report(s)
                    </div>
                }
                
                {/* Top Section: Details */}
                <div className="flex py-[1.2vmax] items-center">
                    <div className="text-center flex-[0.4] text-zinc-400 font-jakarta font-bold text-[0.9vmax]" >
                        {displayIndex}
                    </div>
                    <div className="px-[1vmax] flex-[1.2] flex gap-[0.5vmax] items-center" >
                        <div className="w-[2vmax] h-[2vmax]" >
                            <img src={PMM?.avatar_url || DefaultAvatar} alt="" className="w-full h-full rounded-full border border-zinc-100" />
                        </div>
                        <span className="text-zinc-800 font-jakarta font-bold text-[0.85vmax]" >{PMM?.name}</span>
                    </div>
                    <div className="px-[1vmax] flex-[2.2] flex items-center" >
                        <span className="text-zinc-500 font-jakarta text-[0.8vmax] lowercase" >
                            <HoverFullText text={PMM?.email} sliceLength={25} />
                        </span>
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1] text-gray-700 font-bold text-[0.9vmax]" >
                        {PMM?.orders_count || 0}
                    </div>

                    <div className="flex-center px-[0.5vmax] flex-[1] text-gray-700 font-bold text-[0.9vmax] gap-1" >
                        {PMM?.id || "000"}
                        <button
                            onClick={() => handleCopy(PMM?.id)}
                            className="text-gray-400 hover:text-indigo-600 transition-colors"
                            title={copied ? "Copied" : "Copy"}
                        >
                            <i className={`fa-regular ${copied ? "fa-circle-check text-emerald-500" : "fa-copy"}`}></i>
                        </button>
                    </div>

                    <div className="flex flex-col items-center justify-center text-center px-[0.5vmax] flex-[1.2] text-gray-700 text-[0.9vmax]" >
                        <span className="font-bold text-gray-800">
                            <HoverFullText text={PMM?.referal_name || "N/A"} sliceLength={12} />
                        </span>
                        {PMM?.refered_by && (
                            <span className="text-gray-400 text-[0.8vmax]">ID: {PMM?.refered_by}</span>
                        )}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1] text-gray-500 text-[0.85vmax]" >
                        {formatDbDateWithoutTime(PMM?.created_at)}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1] text-gray-700 font-medium text-[0.9vmax]" >
                        <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider 
                            ${PMM?.status === "ACTIVE" ? "text-emerald-600 bg-emerald-50" :
                              PMM?.status === "BLOCKED" ? "text-rose-600 bg-rose-50" : "text-amber-600 bg-amber-50"}`}
                        >
                            {PMM?.status === "ACTIVE" ? "Active" :
                             PMM?.status === "BLOCKED" ? "Blocked" : "Suspended"}
                        </span>
                    </div>

                    <div className="flex justify-center flex-[2.2] items-center relative" ref={dropdownRef}>
                        <button 
                            onClick={() => setShowDropdown(!showDropdown)}
                            className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.75vmax] font-bold transition-colors text-white flex items-center gap-1 
                                ${PMM?.status === "ACTIVE" ? "bg-emerald-600 hover:bg-emerald-700" :
                                  PMM?.status === "BLOCKED" ? "bg-rose-600 hover:bg-rose-700" : 
                                  "bg-amber-600 hover:bg-amber-700"}`}
                        >
                            {PMM?.status === "ACTIVE" ? "Active" :
                             PMM?.status === "BLOCKED" ? "Blocked" : 
                             PMM?.status === "TEMPORARILY_BLOCKED" ? "Temp Blocked" : "Pending"}
                            <i className="fa-solid fa-chevron-down text-xs"></i>
                        </button>
                        
                        {showDropdown && (
                            <div className="absolute right-0 top-full mt-1 w-[170px] bg-white border border-gray-100 shadow-lg rounded-lg z-[10] overflow-hidden">
                                <Link 
                                    to={`/dashboard/user-details?user_id=${PMM?.id}`} 
                                    className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                                    onClick={() => setShowDropdown(false)}
                                >
                                    <i className="fa-regular fa-eye mr-2 w-4"></i> View Details
                                </Link>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${PMM?.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={PMM?.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform("BLOCKED")
                                        setPopupHeading(`Block ${PMM.name}`)
                                        setPopupPara(`This PMM may have pending orders. Blocking this user will cancel the all orders currently in process. Do you want to continue?`)
                                    }}
                                >
                                    <i className="fa-solid fa-user-slash mr-2 w-4"></i> Block Permanently
                                </button>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${PMM?.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={PMM?.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform(PMM.status === "TEMPORARILY_BLOCKED" ? "ACTIVE" : "TEMPORARILY_BLOCKED")
                                        setPopupHeading(`${PMM.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : " Temporarily Block"} ${PMM.name}`)
                                        setPopupPara(PMM.status === "TEMPORARILY_BLOCKED" ?
                                            `Are you sure want to mark ${PMM.name} active again?` :
                                            `Are you sure you want to temporarily block ${PMM.name}? All of their pending orders, and active reservations will be suspended until the user is reactivated.`)
                                    }}
                                >
                                    <i className="fa-solid fa-user-clock mr-2 w-4"></i> {PMM?.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : "Block Temporarily"}
                                </button>

                                {user?.role === "SUPER_ADMIN" && PMM?.status === "PENDING_APPROVAL" && (
                                    <button 
                                        className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-red-600 hover:bg-red-50 font-medium"
                                        onClick={() => {
                                            setShowDropdown(false)
                                            setShowPopup(true)
                                            setActionToPerform("DELETE")
                                            setPopupHeading(`Delete ${PMM.name}`)
                                            setPopupPara(`Are you sure you want to permanently delete ${PMM.name}? This action cannot be undone.`)
                                        }}
                                    >
                                        <i className="fa-solid fa-trash-can mr-2 w-4"></i> Delete User
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showPopup &&
                <section className="flex justify-center w-[100vw] h-[100vh] fixed top-0 left-0 
            bg-[#0000006c] z-[9999999999]">
                    <button className="text-[2.5vmax] text-white fixed top-[2vmax] right-[2vmax]"
                        onClick={() => {
                            setShowPopup(false)
                            setActionToPerform("")
                            setPopupHeading("")
                            setPopupPara("")
                        }}
                    >
                        <div className="fa-solid fa-xmark"></div>
                    </button>
                    <div className="bg-white shadow-lg   rounded-[2vmax] h-fit mt-[2vmax] ">
                        <h2 className="text-[1.4vmax] font-3 font-[900] text-white p-[0.5vmax_3vmax] bg-[var(--secondary)] mb-[1vmax] text-center" >{popupHeading}</h2>
                        <p className='max-w-[33vmax] p-[0vmax_2vmax_2vmax_2vmax] text-gray-600 font-[600] font-3' >
                            {popupPara}
                        </p>
                        <div className="flex justify-end gap-[1vmax] p-[2vmax] pt-0">
                            <button className="text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-3)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => {
                                    setShowPopup(false)
                                    setActionToPerform("")
                                    setPopupHeading("")
                                    setPopupPara("")
                                }}
                            >
                                No, Cancel
                            </button>
                            <button className="text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-5)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleUpdateStatus(PMM?.id, actionToPerform)}
                            >
                                Yes Proceed
                            </button>
                        </div>
                    </div>
                </section>
            }
        </Fragment>
    )
}

export default SingleAdmin